import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, ExpandAltOutlined, PlusOutlined, PlusSquareFilled, SearchOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Flex, Form, Grid, Input, Modal, Row, Select, Space, Table, Tabs, Tooltip, type FormInstance, type TabsProps } from "antd";
import React, { useEffect, useState } from "react";
import type { IConvenente, ISelectList, ITipo, IPessoaJuridica } from "../../../components/Interfaces";
import type { CheckboxProps } from "antd/lib";
import { errorMessage, successMessage } from "../../../messages/messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListCheck, faPiggyBank } from "@fortawesome/free-solid-svg-icons";
import type { AlignType } from "rc-table/lib/interface";
import { hasPermissao, Papel } from "../../../components/auth/entidadeUsuario";
import { maskCnpj } from "../../../utils/maskFunctions";
import api from "../../../services/api";
import { onlyNumbers } from "../../../utils/utilsFunctions";

interface IProps {
    form: FormInstance<any>;
    convenentes: IConvenente[];
    caracteristica: number;
    setConvenentes: React.Dispatch<React.SetStateAction<IConvenente[]>>;
    listTipoInstituidor: ISelectList[];
    manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

const { useBreakpoint } = Grid;

const Convenente = ({ form, convenentes, setConvenentes, caracteristica, listTipoInstituidor, manter }: IProps) => {
    // const [form] = Form.useForm();
    const screens = useBreakpoint();

    const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
    const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
    const [exibirModalConvenente, setExibirModalConvenente] = useState(false);

    const [tipoInstituidor, setTipoInstituidor] = useState(0);

    const [exibirConvenentesCadastrados, setExibirConvenentesCadastrados] = useState("none");

    const [pessoaJuridicaNacional, setPessoaJuridicaNacional] = useState(true);
    const [pessoaJuridica, setPessoaJuridica] = useState<IPessoaJuridica>();
    const [numeroAProcessar, setNumeroAProcessar] = useState("");
    // Flag para disparar o Carregamento da Pagina
    const [loading, setLoading] = useState(false);
    const [tipLoading, setTipLoading] = useState("");

    useEffect(() => {
        if (manter === 2) { // Estamos no modo Detalhar
            setExibirElementoAcaoAlteracao("none");
        } else {
            setExibirElementoAcaoAlteracao("inline");
        }
    }, [manter])

    useEffect(() => {
        if (numeroAProcessar !== "") {
            getPessoaJuridicaByTpIdentificadorAndNumero(onlyNumbers(numeroAProcessar), pessoaJuridicaNacional ? 1 : 2)
        }
    }, [numeroAProcessar])

    useEffect(() => {
        //console.log(pessoaJuridica);
        if (pessoaJuridica) {
            //console.log("xxx");

            form.setFieldsValue({
                razaoSocial: pessoaJuridica.razaoSocial,
                nomeFantasia: pessoaJuridica.nomeFantasia,
                atividadeEconomica: "",
                nmNaturezaJuridica: pessoaJuridica.naturezaJuridica,
                logradouro: "xx"
            });
        }
    }, [pessoaJuridica])

    useEffect(() => {
        if (convenentes.length === 0) {
            setExibirConvenentesCadastrados("none")
        } else {
            setExibirConvenentesCadastrados("inline")
        }
    }, [convenentes]);

    useEffect(() => {
        if (estadoModal === 3) { // EM EDIÇÃO
            controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
        } else if (estadoModal === 2) { // EXIBIR DETALHES
            controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
        }
    }, [estadoModal])

    const setDadosConvenente = () => {
        const currentForm = form.getFieldsValue();

        if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
            setConvenentes(pre => {
                return pre.map(convenente => {
                    if (convenente.emEdicao) {
                        return ({
                            id: convenente.id,
                            convenioDeAdesaoId: convenente.convenioDeAdesaoId,
                            seriePlano: convenente.seriePlano,
                            csTpInstituidor: currentForm.csTpInstituidor,
                            qtdePessoaAbaixoTeto: currentForm.qtdePessoaAbaixoTeto,
                            idadeMediaAbaixoTeto: currentForm.idadeMediaAbaixoTeto,
                            remuneracaoMediaAbaixoTeto: currentForm.remuneracaoMediaAbaixoTeto,
                            qtdePessoaAcimaTeto: currentForm.qtdePessoaAcimaTeto,
                            idadeMediaAcimaTeto: currentForm.idadeMediaAcimaTeto,
                            remuneracaoMediaAcimaTeto: currentForm.remuneracaoMediaAcimaTeto,
                            emEdicao: false,
                            marcadoParaExclusao: false,
                        })
                    } else {
                        return convenente
                    }
                })
            });
        } else {
            setConvenentes([
                ...convenentes,
                {
                    id: "",
                    convenioDeAdesaoId: "",
                    seriePlano: -1,
                    csTpInstituidor: currentForm.csTpInstituidor,
                    qtdePessoaAbaixoTeto: currentForm.qtdePessoaAbaixoTeto,
                    idadeMediaAbaixoTeto: currentForm.idadeMediaAbaixoTeto,
                    remuneracaoMediaAbaixoTeto: currentForm.remuneracaoMediaAbaixoTeto,
                    qtdePessoaAcimaTeto: currentForm.qtdePessoaAcimaTeto,
                    idadeMediaAcimaTeto: currentForm.idadeMediaAcimaTeto,
                    remuneracaoMediaAcimaTeto: currentForm.remuneracaoMediaAcimaTeto,
                    emEdicao: false,
                    marcadoParaExclusao: false,
                },
            ]);
        }
        limpaDados();
        setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
    }


    function gerarColunas() {
        let cols: any[] = [];

        cols.push(
            {
                title: "Pessoa Jurídica Nacional",
                dataIndex: "",
                render: (conv: IConvenente) => (
                    <Flex align="center" style={{ height: '100px' }}>
                        <Checkbox checked={conv.pessoaJuridica?.tipoIdentificador === 1} onChange={onChangePessoaJuridicaNacional}>Pessoa Jurídica Nacional</Checkbox>
                    </Flex>)
            });

        cols.push(
            {
                title: "CNPJ",
                dataIndex: "",
                render: (conv: IConvenente) => (
                    <>
                        <div style={{ display: conv.pessoaJuridica?.tipoIdentificador === 1 ? "inline" : "none" }}>
                            maskCnpj(conv.pessoaJuridica?.numero)
                        </div>

                        <div style={{ display: conv.pessoaJuridica?.tipoIdentificador === 2 ? "inline" : "none" }}>
                            conv.pessoaJuridica?.numero
                        </div>
                    </>
                )
            });

        cols.push(
            {
                title: "Nome Empresarial",
                dataIndex: "",
                render: (conv: IConvenente) => (
                    conv.pessoaJuridica?.razaoSocial
                )
            });

        cols.push({
            key: "9",
            title: "Opções",
            width: 40,
            dataIndex: "",
            align: 'center' as AlignType,
            render: (ben: IConvenente) => (
                <>
                    <Space>
                        <div style={{ display: manter === 2 ? "inline" : "none" }}>
                            <ExpandAltOutlined
                                title="Detalhar"
                                style={{ color: "blue", marginLeft: 12 }}
                                onClick={() => {
                                    validaAlterarDetalharConvenente(ben, 2);
                                }}
                            />
                        </div>

                        <div style={{ display: manter === 1 && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : exibirElementoAcaoAlteracao }}>
                            <EditOutlined
                                title="Editar"
                                style={{ color: "blue", marginLeft: 12 }}
                                onClick={() => {
                                    validaAlterarDetalharConvenente(ben, 3);
                                    // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                                    convenentes.forEach(b => {
                                        if (b === ben) {
                                            b.emEdicao = estadoModal === 3 ? true : false;
                                        } else {
                                            b.emEdicao = false;
                                        }
                                    })
                                    ben.emEdicao = true;
                                }}
                            />

                            <DeleteOutlined
                                title="Excluir registro ainda não gravado na base."
                                style={{ color: "red", display: (ben?.id && ben?.id === "") ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                                onClick={() => {
                                    setConvenentes(convenentes.filter((b) => b !== ben));
                                }}
                            />
                        </div>

                        <div style={{ display: (ben?.id && ben?.id !== "") && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
                            <>
                                <PlusSquareFilled
                                    title="Desmarcar para exclução"
                                    style={{ color: "blue", display: (ben.marcadoParaExclusao) ? "inline" : "none" }}
                                    onClick={() => {
                                        ben.marcadoParaExclusao = !ben.marcadoParaExclusao; // INVERTE ENTRE 1 (REGISTRO ATUAL ATIVO) E 2 (REGISTRO ATUAL DELETADO)
                                        setConvenentes(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                                            return pre.map(b => {
                                                if (b.id === ben.id) {
                                                    return ben;
                                                } else {
                                                    return b;
                                                }
                                            });
                                        });
                                    }}
                                />
                            </>

                            <>
                                <DeleteOutlined
                                    title="Marcar para exclução/inativação"
                                    style={{ color: "red", display: (!ben.marcadoParaExclusao) ? "inline" : "none" }}
                                    onClick={() => {
                                        ben.marcadoParaExclusao = !ben.marcadoParaExclusao; // INVERTE ENTRE 1 (REGISTRO ATUAL ATIVO) E 2 (REGISTRO ATUAL DELETADO)
                                        setConvenentes(pre => {
                                            return pre.map(b => {
                                                if (b.id === ben.id) {
                                                    return ben;
                                                } else {
                                                    return b;
                                                }
                                            });
                                        });
                                    }}
                                />
                            </>
                        </div>
                    </Space>
                </>
            ),
        })

        return cols.filter(Boolean);
    }
    const columns = gerarColunas();

    const handleCancel = () => {
        setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
        controleDaGrid("cancelar");
        limpaDados();
    };


    const validaInserirConvenente = () => {
        form
            .validateFields()
            .then(() => {
                controleDaGrid("incluir Convenente");
            })
            .catch((_error) => {
                errorMessage("Campo obrigatório não preechido");
            });
    }

    const controleDaGrid = (botao: string) => {
        if (botao === "cancelar") {
            setExibirModalConvenente(false);
            setExibirElementoAcaoAlteracao("inline");
        } else if (botao === "incluir") {
            setExibirModalConvenente(false);
            setExibirElementoAcaoAlteracao("inline");
        } else {
            setExibirModalConvenente(true);
            setExibirElementoAcaoAlteracao("none");
        }

        if (manter === 2) { // Estamos no modo Detalhar
            setExibirElementoAcaoAlteracao("none");
        }
    };

    const handleTipoInstituidor = async (tpInst: any) => {
        setTipoInstituidor(tpInst.key);
        form.setFieldsValue({
            "nmTpInstituidor": tpInst.value,
        })
    };

    const validarConvenente = () => {
        let dadosValidados: Boolean = false;
        form
            .validateFields()
            .then(() => {
                if (!validarCampos()) {
                    return
                }
                dadosValidados = true;
                controleDaGrid("incluir");
                setDadosConvenente();
                successMessage(manter === 3 ? "Benefício Alterado" : "Benefício Adicionado");
            })
            .catch((error) => {
                errorMessage(error.message);

                if (!dadosValidados) {
                    errorMessage("Campo obrigatório não preechido ou não validado");
                } else {
                    errorMessage(error.message);
                }
            });
    };

    function validarCampos(): boolean {

        if (tipoInstituidor === 0 && caracteristica === 2) { // PLANO INSTITUIDO
            errorMessage("Tipo de Instituidor não identificado");
            return false;
        }

        return true;
    }

    function limpaDados() {
        form.resetFields([
            "csTpInstituidor",
            "nmTpInstituidor",
            "qtdePessoaAbaixoTeto",
            "idadeMediaAbaixoTeto",
            "remuneracaoMediaAbaixoTeto",
            "qtdePessoaAcimaTeto",
            "idadeMediaAcimaTeto",
            "remuneracaoMediaAcimaTeto"
        ])
        setTipoInstituidor(0);
    }

    const validaAlterarDetalharConvenente = (ben: IConvenente, estado: number) => {
        form
            .validateFields()
            .then(() => {
                setFieldsDetalharEditar(ben);
                setEstadoModal(estado); // SET O MODO DETALHAR
            })
            .catch((_error) => {
                errorMessage("Campo obrigatório não preechido");
            });
    }

    const setFieldsDetalharEditar = (convenente: IConvenente) => {
        getPessoaJuridicaBySerie(convenente.seriePlano);
        form.setFieldsValue({
            csTpInstituidor: convenente.csTpInstituidor,
            nmTpInstituidor: listTipoInstituidor.find(l => l.value === convenente.csTpInstituidor)?.label,
            qtdePessoaAbaixoTeto: convenente.qtdePessoaAbaixoTeto,
            idadeMediaAbaixoTeto: convenente.idadeMediaAbaixoTeto,
            remuneracaoMediaAbaixoTeto: convenente.remuneracaoMediaAbaixoTeto,
            qtdePessoaAcimaTeto: convenente.qtdePessoaAcimaTeto,
            idadeMediaAcimaTeto: convenente.idadeMediaAcimaTeto,
            remuneracaoMediaAcimaTeto: convenente.remuneracaoMediaAcimaTeto
        });
    }

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Endereço',
            icon: <FontAwesomeIcon icon={faPiggyBank} />,
            children:
                <>
                </>
        },
        {
            key: '2',
            label: 'Pessoas Vinculadas',
            icon: <FontAwesomeIcon icon={faListCheck} />,
            children:
                <>
                </>
        }
    ];

    const getPessoaJuridicaBySerie = async (serie: number) => {
        try {
            setLoading(true);

            let lQuery = `/ultimo/${serie}/serie`;

            await api.get(lQuery).then((response) => {
                setPessoaJuridica(response.data);
            })

        } catch (error: any) {
            errorMessage("Não foi possível realizar a consulta da Pessoa Jurídica. " + error?.message);
        } finally {
            setLoading(false);
        }
    };

    const getPessoaJuridicaByTpIdentificadorAndNumero = async (numero: string, tipoIdentificador: number) => {
        try {
            setLoading(true);

            let lQuery = `/ultimo/${tipoIdentificador}/${numero}/numero`;

            await api.get(lQuery).then((response) => {
                setPessoaJuridica(response.data);
            })

        } catch (error: any) {
            errorMessage("Não foi possível realizar a consulta da Pessoa Jurídica. " + error?.message);
        } finally {
            setLoading(false);
        }
    };


    const onChangePessoaJuridicaNacional: CheckboxProps['onChange'] = (e) => {
        setPessoaJuridicaNacional(e.target.checked);
    };

    return (
        <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >
            <Button
                style={{ display: exibirElementoAcaoAlteracao }}
                id="incluirConvenente"
                type="primary"
                shape="round"
                onClick={() => {
                    limpaDados();
                    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
                    validaInserirConvenente();
                }}
                icon={<PlusOutlined />}
            >
                Incluir Convenente
            </Button>
            <>
                <Modal title="Incluir Convenente" open={exibirModalConvenente}
                    style={{ top: 20 }}
                    width={screens.xs ? 750 : 1000}
                    destroyOnHidden={true}
                    closable={false}
                    footer={[
                        <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
                            {estadoModal === 2 ? "Fechar" : "Cancelar"}
                        </Button>,
                        <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
                            key="ok" type="primary" onClick={validarConvenente}>
                            {estadoModal === 3 ? "Alterar" : "Incluir"}
                        </Button>,
                    ]}
                >
                    <Row>

                        <Col xs={24} md={12} xl={5} >
                            <Flex align="center" style={{ height: '100px' }}>
                                <Checkbox checked={pessoaJuridicaNacional} onChange={onChangePessoaJuridicaNacional}>Pessoa Jurídica Nacional</Checkbox>
                            </Flex>
                        </Col>

                        <Col xs={24} md={12} xl={7} hidden={!pessoaJuridicaNacional}>
                            <Form.Item
                                label='CNPJ'
                                name='cnpjNumero'>
                                <Input maxLength={18}
                                    disabled={!pessoaJuridicaNacional}
                                    onChange={(e) =>
                                        form.setFieldsValue({
                                            cnpjNumero: maskCnpj(e.target.value),
                                        })
                                    }
                                    onBlur={(e) =>
                                        setNumeroAProcessar(e.target.value)
                                    }
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12} xl={2} hidden={!pessoaJuridicaNacional}>
                            <Tooltip title='Buscar CNPJ'>
                                <Button
                                    shape='round' type='primary' icon={<SearchOutlined />}
                                    disabled={!pessoaJuridicaNacional}
                                    style={{ marginTop: "30px", marginLeft: "3px" }}
                                    onClick={() => {
                                        if (numeroAProcessar !== form.getFieldValue('cnpjNumero')) {
                                            setNumeroAProcessar(form.getFieldValue('cnpjNumero'));
                                        }
                                    }} >
                                    {/* Buscar CNPJ */}
                                </Button>
                            </Tooltip>
                        </Col>

                        <Col xs={24} md={12} xl={7} hidden={pessoaJuridicaNacional}>
                            <Form.Item
                                label='Número de Identificação Fiscal (NIF)'
                                name='numeroIdentificacaoFiscal'
                            >
                                <Input maxLength={18}
                                    disabled={pessoaJuridicaNacional}
                                    onBlur={(e) =>
                                        setNumeroAProcessar(e.target.value)
                                    }
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12} xl={2} hidden={pessoaJuridicaNacional}>
                            <Tooltip title='Buscar NIF'>
                                <Button
                                    shape='round' type='primary' icon={<SearchOutlined />}
                                    disabled={pessoaJuridicaNacional}
                                    style={{ marginTop: "30px", marginLeft: "3px" }}
                                    onClick={() => {
                                        if (numeroAProcessar !== form.getFieldValue('numeroIdentificacaoFiscal')) {
                                            setNumeroAProcessar(form.getFieldValue('numeroIdentificacaoFiscal'));
                                        }
                                    }} >
                                    {/* Buscar NIF */}
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} xl={15}>
                            <Form.Item
                                label='Nome Empresarial'
                                name='razaoSocial'
                            >
                                <Input disabled />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} xl={7}>
                            <Form.Item
                                label='Nome Fantasia'
                                name='nomeFantasia'
                            >
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={8} hidden={caracteristica === 1}>
                            <Form.Item label="Tipo de Convênio"
                                labelAlign="left"
                                labelCol={{ span: 20 }}
                                name="nmTpInstituidor"
                                colon={false}
                                rules={[
                                    {
                                        required: manter !== 2 && caracteristica === 2 ? true : false,
                                        message: "Selecione o Tipo de Instituidor",
                                    },
                                ]}
                            >
                                <Select
                                    disabled={manter === 2 ? caracteristica === 1 ? true : false : false}
                                    placeholder="Tipo de Instituidor"
                                    showSearch
                                    filterOption
                                    optionFilterProp='children'
                                    options={listTipoInstituidor}
                                    onChange={(_, index) => {
                                        handleTipoInstituidor(index);
                                    }}
                                />

                            </Form.Item>
                        </Col>

                    </Row>

                    <Row>
                        <Col xs={24} md={12} xl={12}>
                            <Form.Item
                                label='Atividade Econômica Principal'
                                name='atividadeEconomica'>
                                <Input disabled />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} xl={12}>
                            <Form.Item
                                label='Natureza Jurídica'
                                name='nmNaturezaJuridica'
                            >
                                <Select disabled />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Tabs
                        defaultActiveKey="1"
                        items={items}
                    // onChange={onChange} 
                    />
                </Modal>

                <Row style={{ display: exibirConvenentesCadastrados }}>
                    <Col
                        xs={24}
                        sm={24}
                    >
                        <Table
                            size="small" rowKey="nome" columns={columns} dataSource={convenentes} pagination={false} />
                    </Col>
                </Row>
            </>
        </Form>
    )
};

export default Convenente;

